import { render, staticRenderFns } from "./ChallengeGridCell.vue?vue&type=template&id=4d8a00e8&scoped=true"
import script from "./ChallengeGridCell.vue?vue&type=script&lang=js"
export * from "./ChallengeGridCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a00e8",
  null
  
)

export default component.exports